<div class="back-button my-4">
  <a
    role="button"
    draggable="false"
    class="c-button back-button__a c-button--transparent"
    (click)="goBack()">
    <div class="back-button__a__box">
      <span class="back-button__a__box__text">
        <i class="mr-1 pi pi-arrow-left"></i>
        Volver
      </span>
    </div>
  </a>
</div>
